import React, {useEffect, useState} from 'react';
import SideNavbar from '../../Components/SideNavbar';
import './CSS/Admin.css';
import { TiUserAddOutline, TiUserDeleteOutline } from "react-icons/ti";
import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const initialUsers = [
    {
        username: 'cody.hagel@vizelabs.com',
        email: 'cody.hagel@vizelabs.com',
        verified: true,
        seatId: ''
    },
];

const Admin: React.FC = () => {
    const [users, setUsers] = useState(initialUsers);
    const [filter, setFilter] = useState('');
    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);



    const subjectToken = localStorage.getItem('subjectToken');


    const filteredUsers = users.filter(user =>
        user.username.toLowerCase().includes(filter.toLowerCase()) ||
        user.email.toLowerCase().includes(filter.toLowerCase())
    );

    useEffect(() => {
        const getSeats = async () => {
            try {
                const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/seats';

                const response = await axios.get(endpoint, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${subjectToken}`, // Replace with the actual token
                    }
                });

                setUsers(response.data.value);
                setLoading(false);
                // Handle the seat data as needed, e.g., set state
            } catch (error) {
                console.error('Error fetching seats:', error);
            }
        };

        getSeats();
    }, []);

    const handleAddUser = async () => {
        const email = prompt("Enter the user's email:");
        if (!email || !email.trim()) {
            alert('Email is required!');
            return;
        }


        const subjectToken = localStorage.getItem('subjectToken'); // Retrieve stored token
        if (!subjectToken) {
            alert('Authentication token not found. Please sign in again.');
            return;
        }


        try {
            const response = await fetch(REACT_APP_API_URL + '/api/v1.0/desktop/seats', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${subjectToken}`,
                },
                body: email,
            });

            if (!response.ok) {
                throw new Error('Failed to add user');
            }

            // Optionally handle the backend response, e.g., show success message
            const result = await response.json();
            alert('User added successfully!');


        } catch (error) {
            console.error('Error adding user:', error);
            alert('There was an error adding the user. Please try again.');
        }
    };

    const handleCheckboxChange = (email: string) => {
        if (selectedUsers.includes(email)) {
            setSelectedUsers(selectedUsers.filter(userEmail => userEmail !== email));
        } else {
            setSelectedUsers([...selectedUsers, email]);
        }
    };

    const handleDeleteUsers = async () => {
        if (selectedUsers.length === 0) {
            alert('No users selected.');
            return;
        }

        const confirmDelete = window.confirm('Are you sure you want to delete these users?');
        if (confirmDelete) {
            try {
                const deletePromises = selectedUsers.map(async (email) => {
                    const user = users.find((user) => user.email === email);
                    if (user && user.seatId) {
                        const deleteEndpoint = REACT_APP_API_URL + `/api/v1.0/desktop/seats/${user.seatId}`;
                        await axios.delete(deleteEndpoint, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${subjectToken}`,
                            },
                        });
                    }
                });

                // Wait for all delete requests to complete
                await Promise.all(deletePromises);

                // Update the users state after deletion
                setUsers(users.filter((user) => !selectedUsers.includes(user.email)));
                setSelectedUsers([]);
                alert('Selected users deleted successfully!');
            } catch (error) {
                console.error('Error deleting users:', error);
                alert('There was an error deleting the users. Please try again.');
            }
        }
    };

    if (loading) {
        return (
            <div className="admin-page">
                <SideNavbar/>
                <div className="admin-content">
                    <div className="admin-header">
                        <h1>Admin / Users</h1>
                    </div>
                </div>
            </div>
        ) // Display loading message until data is ready
    }


    return (
        <div className="admin-page">
            <SideNavbar/>
            <div className="admin-content">
                <div className="admin-header">
                    <h1>Admin / Users</h1>
                </div>

                <div className="table-container">
                    <div className="table-actions">
                        <button onClick={handleAddUser}>Add User <TiUserAddOutline/></button>
                        <button onClick={handleDeleteUsers}>Delete <TiUserDeleteOutline/></button>
                        <input
                            type="text"
                            placeholder="Search for..."
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                        />
                        <span className="user-count">Total Users: {filteredUsers.length}</span>
                    </div>

                    <table>
                        <thead>
                        <tr>
                            <th className="checkbox-column"></th>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Verified</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.map((user, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedUsers.includes(user.email)}
                                        onChange={() => handleCheckboxChange(user.email)}
                                    />
                                </td>
                                <td>{user.username}</td>
                                <td>{user.email}</td>
                                <td><input type="checkbox" checked={user.verified} readOnly/></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Admin;
